module.exports = __webpack_public_path__ + "img/27_87.0286afaa.png";